<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <aurora-icon-button class="close" icon="times" variant="ghost" size="large" aria-label="Close" (click)="dismiss()">
  </aurora-icon-button>
</div>
<div class="modal-body" style="font-size: 14px; white-space: pre-line">
  {{ message }}
</div>
<div class="modal-footer">
  <aurora-button variant="primary" (click)="accept()" ngbAutofocus>
    {{ btnOkText }}
  </aurora-button>
  <aurora-button variant="ghost" (click)="decline()">{{ btnCancelText }}</aurora-button>
</div>
